module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    class: [
      ("" + (_vm.block.slug)),
      "home-block" ],
    attrs: {
      "block": _vm.block.block
    }
  }, [_c('div', {
    class: [
      "home-block__inner",
      _vm.block.reversed ? "home-block--reversed" : "",
      _vm.block.large ? "home-block--large" : "",
      ("home-block--" + (_vm.block.block)), !_vm.block.large ? "group group--first-last-small" : "" ]
  }, [_c('div', {
    class: [
      "home-block__image",
      _vm.block.large ? "home-block__image--large" : "",
      ("home-block__image--" + (_vm.block.block)) ],
    style: (("backgroundImage: url(" + (_vm.block.image.image) + ")"))
  }), _vm._v(" "), _c('module-home-content', {
    attrs: {
      "content": _vm.block.content
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcf4f0c8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/home/Block.vue
// module id = 254
// module chunks = 0